import { show } from 'redux-modal'
import { CHANGED_AVAILABILITY_PRICE_MODAL } from './constants'

export const showChangedAvailabilityPriceModal = productsWithChangedAvailabilityOrPrice => (
  show(CHANGED_AVAILABILITY_PRICE_MODAL, { productsWithChangedAvailabilityOrPrice })
)
